module.exports = __webpack_public_path__ + "@/assets/img/locked-folder.73301a9e.svg";